
import { defineComponent, PropType } from "vue";
import Modal from "@/components/Modal.vue";
import ImprovementForm from "@/improvementForms/ImprovementForm.vue";
import { FormTypes } from "@/improvementForms/formTypes";

export default defineComponent({
  props: {
    formType: {
      type: String as PropType<FormTypes>,
      required: true,
    },
    objectId: {
      type: String,
      required: false,
    },
  },
  components: { ImprovementForm, Modal },
  methods: {
    open() {
      // @ts-ignore: Klasyczny Vue nie obsługuje typowania referencji
      this.$refs["modal"].open();
    },
  },
});
